import { Component, input, ChangeDetectionStrategy } from '@angular/core';

import { IconComponent, IconName, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-insights-card',
  templateUrl: './insights-card.component.html',
  styleUrl: 'insights-card.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent, RtTooltip],
})
export class InsightsCardComponent {
  public iconName = input.required<IconName>();
  public value = input.required<string>();
  public title = input.required<string>();
  public label = input.required<string>();
  public tooltip = input<string>();
}
